import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../store/reducers';
import { ActivatedRoute, Router } from '@angular/router';
import {
  citizenVerifyOtpNumber,
  resendOtpNumber
} from "../../../../store/entities/citizens/register/citizen-verify-opt-number/citizen-verify-opt-number.actions";

@Component({
  selector: 'app-otp-verification',
  templateUrl: './otp-verification.component.html',
  styleUrls: ['./otp-verification.component.scss'],
})
export class OtpVerificationComponent implements OnInit {
  otpForm: FormGroup;
  errorMessage = '';
  type: string;
  timer: number;
  interval: any;
  isTimerExpired: boolean = false;

  phoneOrEmail: string;
  originalPhoneOrEmail: string;
  navTo: string;
  isEditing: boolean = false;

  constructor(
    private fb: FormBuilder,
    private store: Store<AppState>,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {
    this.otpForm = this.fb.group({
      0: ['', [Validators.required, Validators.pattern('\\d')]],
      1: ['', [Validators.required, Validators.pattern('\\d')]],
      2: ['', [Validators.required, Validators.pattern('\\d')]],
      3: ['', [Validators.required, Validators.pattern('\\d')]],
      4: ['', [Validators.required, Validators.pattern('\\d')]],
      5: ['', [Validators.required, Validators.pattern('\\d')]],
    });
    this.type = this.activatedRoute.snapshot.paramMap.get('type');
    this.phoneOrEmail = this.activatedRoute.snapshot.paramMap.get('numberOrEmail') || '';
    this.navTo = this.activatedRoute.snapshot.paramMap.get('navTo') || '';
    this.originalPhoneOrEmail = this.phoneOrEmail;
    this.timer = 300;
  }

  ngOnInit() {
    this.startTimer();
  }

  get otpControls() {
    return Object.keys(this.otpForm.controls);
  }

  onInput(event: any, index: number) {
    if (event.target.value.length === 1 && index < this.otpControls.length - 1) {
      const nextInput = event.target.nextElementSibling;
      nextInput?.focus();
    }
  }

  verifyOtp() {
    const otp = Object.values(this.otpForm.value).join('');
    this.store.dispatch(citizenVerifyOtpNumber({
      otp: otp,
      navTo: this.navTo,
      phoneNumber: this.phoneOrEmail
    }));
  }

  cancel() {
    this.router.navigate(['/login']);
  }

  startTimer() {
    this.interval = setInterval(() => {
      if (this.timer > 0) {
        this.timer--;
        this.cdr.detectChanges();
      } else {
        this.isTimerExpired = true;
        clearInterval(this.interval);
        this.cdr.detectChanges();
      }
    }, 1000);
  }

  resetTimer() {
    clearInterval(this.interval);
    this.timer = 300;
    this.isTimerExpired = false;
    this.startTimer();
    this.resendOtp();
  }

  get formattedTime(): string {
    const minutes = Math.floor(this.timer / 60);
    const seconds = this.timer % 60;
    return `${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
  }

  isEmail(value: string): boolean {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(value);
  }

  toggleEdit() {
    if (this.isEditing) {
      const isEmailInput = this.isEmail(this.phoneOrEmail);
      if (this.phoneOrEmail !== this.originalPhoneOrEmail) {
        this.store.dispatch(resendOtpNumber({
          previousValue: this.originalPhoneOrEmail,
          newValue: this.phoneOrEmail,
          inputType: isEmailInput ? 'EMAIL' : 'PHONE'
        }));
        this.originalPhoneOrEmail = this.phoneOrEmail;
        this.resetTimer();
      }
    }
    this.isEditing = !this.isEditing;
  }

  resendOtp(){
    const isEmailInput = this.isEmail(this.phoneOrEmail);
      this.store.dispatch(resendOtpNumber({
        previousValue: this.originalPhoneOrEmail,
        newValue: this.phoneOrEmail,
        inputType: isEmailInput ? 'EMAIL' : 'PHONE'
      }));
      this.originalPhoneOrEmail = this.phoneOrEmail;
  }
}
